import React, { Component } from "react";
import { connect } from "react-redux";
import axios, { CancelToken } from "axios";
import $ from "jquery";
import _ from "lodash";

import { Translate, I18n } from "react-redux-i18n";

import Form from "react-bootstrap/Form";

import { verifyCode } from "../../../actions/accountActions";
import { setAlert } from "../../../actions/alertActions";

import evio from "../../../styles/images/evio.svg";
import "../../../styles/components/account/createAccount/CodeVerification.scss";

class CodeVerification extends Component {
  constructor(props) {
    super(props);
    this._mounted = false;
    this.cancel = null;

    this.state = {
      validated: false,
    };

    this.handleVerifyCode = this.handleVerifyCode.bind(this);
    this.resend = this.resend.bind(this);
  }

  componentDidMount() {
    this._mounted = true;
  }

  componentWillUnmount() {
    if (this.cancel !== null) this.cancel("Component is unmounting");
    this._mounted = false;
  }

  handleVerifyCode(e) {
    e.preventDefault();

    const form = $(e.target)[0];
    this.safeSetState({ validated: true }, () => {
      if (form.checkValidity() !== false) {
        const elements = form.elements;
        const internationalPrefix = this.props.accountData.internationalPrefix;
        const mobile = this.props.accountData.mobile;
        const code = elements.code.value;

        this.props.verifyCode(internationalPrefix, mobile, code);
      }
    });
  }

  resend(e) {
    e.preventDefault();
    if (_.isEmpty(this.props.accountData)) return;

    const post = {
      mobile: this.props.accountData.mobile,
      internationalPrefix: this.props.accountData.internationalPrefix,
    };

    axios
      .post("/api/accountActivation", post, {
        cancelToken: new CancelToken((c) => (this.cancel = c)),
      })
      .then((res) => {
        this.props.setAlert(I18n.t("signUpVerification_subTitle"), "primary");
      })
      .catch((err) =>
        this.props.setAlert(I18n.t(err.response.data.message), "danger")
      );
  }

  safeSetState(params, callback) {
    if (this._mounted) this.setState(params, callback);
  }

  render() {
    return (
      <div id="codeVerification" className="evio-container">
        <div className="sidemenu">
          <div className="logo-container">
            <img
              src={this.props.brand?.icons?.principalIcon || evio}
              alt={`${this.props.brand?.brandName} logo`}
            />
          </div>
          <div className="form-container">
            <Form
              id="verification-form"
              validated={this.state.validated}
              noValidate
              onSubmit={this.handleVerifyCode}
            >
              <Form.Group className="form-field">
                <p>
                  <Translate value="signUpVerification_subTitle" />
                </p>
              </Form.Group>
              <Form.Group className="form-field">
                <Form.Control
                  type="text"
                  name="code"
                  placeholder={I18n.t("componentVerificationCode_code")}
                  required
                />
              </Form.Group>
              <Form.Group className="form-field">
                <p>
                  <Translate value="componentVerificationCode_didnGetCode" />
                  <a href="#resend" onClick={this.resend} className="link">
                    <Translate value="componentVerificationCode_resend" />
                  </a>
                </p>
              </Form.Group>
            </Form>
          </div>
          <div className="footer-container">
            <button type="submit" form="verification-form">
              <Translate value="componentButton_verify" />
            </button>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  accountData: state.account.accountData,
  brand: state.app.brand,
});

export default connect(mapStateToProps, { verifyCode, setAlert })(
  CodeVerification
);
